export default __webpack_public_path__ + "static/media/gallery_07.d08392e9.jpg";